<script>
    // Licensed under Gnu Public License version 2
    // Copyright (c) 2025 (original work) Open Assessment Technologies SA

    import { __ } from '@oat-sa-private/ui-core';
    import { ButtonLink } from '@oat-sa-private/ui-elements';
    import { CookiePolicy } from '@oat-sa-private/ui-components';

    import { initialize as initializeAnalyticsService } from '@/services/analyticsService';
    import { configurationStore } from '@/store/tenantConfiguration';
    import { user as userStore } from '@/store/auth';

    import { cookiePolicyConfig } from '@/component/CookiePolicyWrapper/cookiePolicyConfig';
    import { createCookieStorage } from 'util/cookies.js';

    import { decodedAccessToken } from '@/store/accessToken';
    import { ltiClaims } from '@/core/utils/consts';

    const userId = $userStore?.userId || 'anonymous';
    const tenantId = $userStore?.tenantId;
    const portalLaunch = $decodedAccessToken[ltiClaims.custom]?.portalLaunch || false;

    const storage = createCookieStorage({ domainLevel: 2 });
    const config = cookiePolicyConfig();

    function handleInitializeCookies(event) {
        if (event.detail?.analytics) {
            initializeAnalyticsService();
        }
    }

    config.privacyPolicyLink.url = $configurationStore?.cookiePolicy?.privacyPolicyLink || config.privacyPolicyLink.url;
    config.cookiePolicyLink.url = $configurationStore?.cookiePolicy?.cookiePolicyLink || config.cookiePolicyLink.url;
    config.display = $configurationStore?.cookiePolicy?.display !== false;
</script>

{#if userId && tenantId && config?.display &&!portalLaunch}
    <CookiePolicy
        storageId={`${tenantId}-${userId}`}
        {storage}
        title={config.title}
        message={config.message}
        options={config.options}
        on:initializeCookies={handleInitializeCookies}>
        <div slot="additional-text">
            {__('You can read more about this in our')}&nbsp;
            <ButtonLink href={config.privacyPolicyLink.url} title={config.privacyPolicyLink.label} target="_blank" />
            &nbsp;{__('and')}&nbsp;
            <ButtonLink href={config.cookiePolicyLink.url} title={config.cookiePolicyLink.label} target="_blank" />
        </div>
    </CookiePolicy>
{/if}
